export default __webpack_public_path__ + "static/logo-d8a549447e3201cfb1c3ef2ac33550d3.jpg";